export const routes = [
  {
    path: "/clinic-checkin",
    name: "clinic-checkin",
    component: () => import("@/modules/clinic-checkin/pages/ClinicCheckIn.vue")
  }
]
